import { Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

const UnsupportedFirmwareDialog = ({ onClose, robotTypeName }) => (
  <>
    <DialogTitle variant="h3" sx={{ textAlign: 'center' }}>
      <Trans i18nkey="error.unsuported_firmware.title">Unsupported Firmware</Trans>
    </DialogTitle>
    <DialogContent>
      <Trans i18nkey="error.unsuported_firmware.content">
        Your {{ robotTypeName }} has firmware that is not supported. To learn how to update your firmware, click on the &quot;Need Help?&quot; link
        below.
      </Trans>
    </DialogContent>
    <DialogActions>
      <Stack direction="column" width="100%">
        <Button variant="contained" onClick={onClose}>
          <Trans i18nKey="button.close" />
        </Button>
        <Button href={'https://support.sphero.com/sphero-edu-firmware-updates-244676'}>
          <Trans i18nKey="button.need_help" />
        </Button>
      </Stack>
    </DialogActions>
  </>
);

UnsupportedFirmwareDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  robotTypeName: PropTypes.string,
};

export default UnsupportedFirmwareDialog;
